import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useFormCreateProductGroup } from '../../controllers/ProductGroups/CreateProductGroupsController';
import LoadingScreen from '../../components/LoadingScreen';

const ProductGroupForm: React.FC = () => {
    const { getProductGroupFormController, handleProductGroupFormController } = useFormCreateProductGroup();
    const history = useHistory();

    const [registerFinished, setRegisterFinished] = useState(false);

    useEffect(() => {
        if (getProductGroupFormController.ProductGroupResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getProductGroupFormController.ProductGroupEditedResponse?.status === 200 && !getProductGroupFormController.ProductGroupResponse) {
            setRegisterFinished(false);
        }
    }, [getProductGroupFormController.ProductGroupResponse, getProductGroupFormController.ProductGroupEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="p-grid p-align-center p-justify-center">
            <Toast ref={getProductGroupFormController.toast} />
            {getProductGroupFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-col-12 p-md-8">
                <div className="card p-fluid">
                    <h5>Grupo de Produto</h5>
                    <div className="p-field">
                        <label htmlFor="name">Nome</label>
                        <InputText id="name" type="text" maxLength={150} disabled={registerFinished}
                            value={getProductGroupFormController.formik.values.DESCRICAO}
                            onChange={getProductGroupFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getProductGroupFormController.formik.touched.DESCRICAO && getProductGroupFormController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getProductGroupFormController.formik.touched.DESCRICAO && getProductGroupFormController.formik.errors.DESCRICAO),
                        })}
                        >{getProductGroupFormController.formik.errors.DESCRICAO}</div>
                    </div>
                    <div className="p-fluid p-grid p-justify-between">
                        {getProductGroupFormController.ProductGroupResponse?.status === 200 && !registerFinished ?
                            <div className="p-col-12 p-md-4">
                                <Button
                                    type="button"
                                    label="Salvar Alterações"
                                    onClick={() => {
                                        getProductGroupFormController.formik.handleSubmit()
                                    }}
                                />
                            </div> :
                            getProductGroupFormController.ProductGroupResponse?.status === 200 && registerFinished ?
                                <div className="p-col-12 p-md-6 p-fluid p-grid" >
                                    <div className="p-col-12 p-md-5">
                                        <Button
                                            type="button"
                                            label="Editar"
                                            onClick={() => {
                                                setRegisterFinished(false);
                                            }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-5" >
                                        <Button
                                            icon="pi pi-plus"
                                            type="button"
                                            className="p-button-success"
                                            label="Cadastrar novo"
                                            onClick={() => {
                                                getProductGroupFormController.formik.resetForm();
                                                setRegisterFinished(false);
                                                handleProductGroupFormController.setProductGroupResponse(null);
                                            }}
                                        />
                                    </div>
                                </div> :
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        type="button"
                                        label="Cadastrar"
                                        onClick={() => getProductGroupFormController.formik.handleSubmit()}
                                    />
                                </div>
                        }

                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                className="p-button-secondary"
                                label="Voltar para listagem"
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ProductGroupForm;